module.exports = __webpack_public_path__ + "static/img/FamilyFirst.826cfd69.jpg";